import { CoreCompatibilityFrag, productMetafields, variantParentCompatibility, variantCompatible, variantNotCompatible, variantTechNotes, variantTechSpecs } from "//decked.com/cdn/shop/t/457/assets/static.graphql-fragments.js?v=73554914647689814541785789560";


class VehicleData {
  static #selectedVehicle = null;
  static selectedVariant = null;
  static variantObjects = {};
  static vehicleObjects = [];
  static filteredVehicleObjects = [];

  constructor() {}

  static init() {
    if (window.__VPV.vehicleData?.initializing || window.__VPV?.vehicleJsonReady) return;
    window.__VPV.vehicleData = window.__VPV.vehicleData || {};
    window.__VPV.vehicleData.initializing = true;

    this.pdpTemplate = window.__VPV?.pdp?.template || null;

    this.fetchData();
    return this.getSelectedVehicle();
  }

  static adjustedProductType(productTemplate) {
    const templateProductType = {
      CargoGlide: "CargoGlide",
      "CargoGlide-DS": "CargoGlide DS Compatible",
      drawers: "Decked",
      "drawers-virtual": "Decked",
      "tool-box": "Tool Box",
      "vxvy-virtual": "Drawers",
    };

    return templateProductType[productTemplate];
  }

  static getDataByVehicle(vehicle) {
    if (!vehicle) {
      return __VPV.vehicleData.byVehicle;
    }

    const filteredData = __VPV.vehicleData.allFormatted.filter(vehicleObj => {
      const makeMatches = vehicle.make ? vehicleObj.make === vehicle.make : true;
      const modelMatches = vehicle.model ? vehicleObj.model === vehicle.model : true;
      const yearMatches = vehicle.year ? vehicleObj.year === vehicle.year : true;
      const bodyStyleMatches = vehicle.body_style ? vehicleObj.body_style === vehicle.body_style : true;
      const bedLengthMatches = vehicle.bed_length ? vehicleObj.bed_length === vehicle.bed_length : true;

      return makeMatches && modelMatches && yearMatches && bodyStyleMatches && bedLengthMatches;
    });

    return filteredData;
  }

  static filterVehicleData(data, variantData) {
    let productType, productHandles;

    // If PDP, filter product prop (array of variants) for product type associated with PDP template type
    if (this.pdpTemplate) {
      if (window.__VPV?.pdp?.use_vpv_button == "productHandle") {
        productHandles = [window.__VPV?.pdp?.productHandle];
      } else if (window.__VPV?.pdp?.use_vpv_button == "productType") {
        productType = window.__VPV?.pdp?.productType;
        if (window.__VPV?.pdp?.productType == "Virtual Product") {
          productType = this.adjustedProductType(this.pdpTemplate);
        }
      } else if (window.__VPV?.pdp?.use_vpv_button == "parentProduct") {
        productHandles = [];
        window.__VPV?.pdp?.variants.forEach(variant => {
          variant.parentVariants.forEach(parentVariant => {
            productHandles.includes(parentVariant.handle) || productHandles.push(parentVariant.handle);
          });
        });
      }
    }

    const filteredProductIds = new Set();
    Object.keys(variantData).forEach(variant => {
      const product = variantData[variant];
      if (productType && product.productType === productType) {
        filteredProductIds.add(product.id);
      }
      if (productHandles && productHandles.includes(product.productHandle)) {
        filteredProductIds.add(product.id);
      }
    });

    const formattedData = data.map(item => {
      const { body_style, products, bed_length } = item;
      const newObj = { ...item };

      newObj.allProducts = products;

      newObj.products = products.filter(product => {
        return filteredProductIds.has(product);
      });

      if (window.__VPV?.pdp?.use_vpv_button == "parentProduct") {
        let childVariants = [];
        const childIds = [];
        newObj.products = newObj.products.map(product => {
          window.__VPV?.pdp?.variants.forEach(variant => {
            const parentIds = variant.parentVariants.map(parentVariant => parentVariant.id.toString());
            if (parentIds.includes(product.split("/").pop()) && !childIds.includes(variant.id)) {
              childIds.push(variant.id);
              childVariants.push({
                id: `gid://shopify/ProductVariant/${variant.id}`,
                sku: variant.sku,
                handle: variant.handle,
                type: variant.type,
                position: variant.position,
              });
            }
          });
          return childVariants;
        });
        newObj.products = childVariants;
      } else {
        newObj.products = newObj.products.map(product => variantData[product]);
      }

      const formattedBodyStyle = body_style?.trim();
      newObj.body_style = formattedBodyStyle || item.year;
      newObj.bed_length = bed_length;

      return newObj;
    });

    if (!productType && !productHandles) {
      return { filteredVehicleObjects: formattedData, formattedVehicleObjects: formattedData };
    }

    // Filter out vehicle objects that have no products (objects that don't match the product type of PDP)
    const filteredVehicleObjects = formattedData.filter(vehicleObj => vehicleObj.products.length);

    return { filteredVehicleObjects, formattedVehicleObjects: formattedData };
  }

  static async fetchData(forceFetch) {
    performance.mark("fetchData-start");

    let previewFile;
    if (window.localStorage) {
      previewFile = window.localStorage.getItem("vehicleDataPreviewFile");
    }

    const JSONFile = (previewFile != "null" && previewFile) || window.themeVariables.settings.vehiclePickerDataSource;

    let localStorageFile = null;
    if (window.localStorage) {
      localStorageFile = window.localStorage.getItem("vehicleDataFile");
    }

    let vehicleData = null,
      variantData = null;
    if (!forceFetch && localStorageFile == JSONFile) {
      try {
        vehicleData = JSON.parse(window.localStorage.getItem("vehicleData"));
        variantData = JSON.parse(window.localStorage.getItem("variantData"));
      } catch (e) {
        console.log("error parsing local storage");
        window.localStorage.setItem("vehicleDataPreviewFile", null);
        this.fetchData(true);
      }
    }

    if (forceFetch || !vehicleData || !variantData) {
      console.log("fetching vehicle data from server");
      const data = await fetch(JSONFile).then(response => response.json());

      variantData = {};
      vehicleData = data.map(item => {
        item.products.forEach(product => {
          variantData[product.id] = product;
        });
        return {
          ...item,
          products: item.products.map(({ id }) => id),
        };
      });
    }

    performance.mark("fetchData-data");
    performance.measure("data", "fetchData-start", "fetchData-data");

    if (window.localStorage) {
      try {
        // remove any old data
        window.localStorage.removeItem("vehicleData-cargoglide");
        window.localStorage.removeItem("vehicleData-cargoglide-ds-compatible");
        window.localStorage.removeItem("vehicleData-drawers");
        window.localStorage.removeItem("vehicleData-tool-box");

        // set the new item
        window.localStorage.setItem("variantData", JSON.stringify(variantData));
        window.localStorage.setItem("vehicleData", JSON.stringify(vehicleData));
        window.localStorage.setItem("vehicleDataFile", JSONFile);
      } catch (e) {
        console.log("error saving local storage: " + e);
      }
    }

    const { filteredVehicleObjects: parsedVehicleData, formattedVehicleObjects } = this.filterVehicleData(vehicleData, variantData);
    this.variantObjects = variantData;
    this.vehicleObjects = parsedVehicleData;

    performance.mark("fetchData-parsed");
    performance.measure("parse", "fetchData-data", "fetchData-parsed");

    window.__VPV.vehicleData.initializing = false;
    window.__VPV.vehicleData.byTemplate = parsedVehicleData;
    window.__VPV.vehicleData.allFormatted = formattedVehicleObjects;

    window.__VPV.vehicleJsonReady = true;
    window.__VPV.updateStore({ vehicleJsonReady: true });

    const vehicleJsonReadyEvent = new CustomEvent("vehicleJsonReady", {
      detail: parsedVehicleData,
      bubbles: true,
      cancelable: true,
      composed: false,
    });
    document.dispatchEvent(vehicleJsonReadyEvent);

    const selectedVehicle = this.getSelectedVehicle();
    // console.log("selectedVariant", this.selectedVariant, this.vehicleObjects);
    let firstOrSelectedVehicleFromSelectedVariant;
    if(this.selectedVariant){

      const variantVehicles = this.vehicleObjects.filter(vehicle => {
        const matchingVariant = vehicle.products.find(variant => {
          return variant.id.indexOf(this.selectedVariant) > -1;
        });
        if(matchingVariant){
          if (vehicle.make == selectedVehicle?.make && vehicle.model == selectedVehicle?.model && vehicle.year == selectedVehicle?.year){
            if(window.__VPV){
              window.__VPV.urlSetVehicleData = false; // don't show the message as we have a matching vehicle
            }
            firstOrSelectedVehicleFromSelectedVariant = vehicle;
          }
        }
        return matchingVariant;
      });

      firstOrSelectedVehicleFromSelectedVariant = firstOrSelectedVehicleFromSelectedVariant || variantVehicles[0];
      if (firstOrSelectedVehicleFromSelectedVariant) {
        const { make, model, year, body_style, bed_length } = firstOrSelectedVehicleFromSelectedVariant;
        this.selectVehicle({ make, model, year, body_style, bed_length });
      }
    }

    if (selectedVehicle && !firstOrSelectedVehicleFromSelectedVariant) {
      const { make, model, year, body_style, bed_length } = selectedVehicle;
      this.selectVehicle({ make, model, year, body_style, bed_length });
    }

    console.log('vehicle data ready...');

    const vehicleDataReadyEvent = new CustomEvent("vehicleDataReady", {
      detail: {
        selectedVehicle,
        vehicleData: window.__VPV.vehicleData.byVehicle,
      },
      bubbles: true,
      cancelable: true,
      composed: false,
    });
    document.dispatchEvent(vehicleDataReadyEvent);

    performance.mark("fetchData-end");

    return parsedVehicleData;
  }

  static getSelectedVehicle() {
    if (!this.#selectedVehicle) {
      this.#selectedVehicle = this.getData("selectedVehicle");
    }

    if (!this.#selectedVehicle) {
      return null;
    } else if (!this.#selectedVehicle.make || !this.#selectedVehicle.model || !this.#selectedVehicle.year) {
      this.resetSelectedVehicle();
      return null;
    }

    window.dataLayer.push({
      vehicle_make: this.#selectedVehicle.make,
      vehicle_model: this.#selectedVehicle.model,
      vehicle_year: this.#selectedVehicle.year,
    });

    return this.#selectedVehicle;
  }

  static searchVehicle({ make, model, year }) {
    const searchResults = this.vehicleObjects.filter(vehicleObj => {
      return vehicleObj.make === make && vehicleObj.model === model && vehicleObj.year === year;
    });

    return searchResults;
  }

  static selectVehicle({ make, model, year, body_style, bed_length }) {
    if (!make || !model || !year) {
      this.resetSelectedVehicle();
      return;
    }

    const searchResults = [];

    this.vehicleObjects.forEach(vehicleObj => {
      if (vehicleObj.make === make && vehicleObj.model === model && vehicleObj.year === year) {
        searchResults.push(vehicleObj);
      }
    });

    window.__VPV.vehicleData.byVehicle = searchResults.sort(function (a, b) {
      if (a.products.length > 0 && b.products.length > 0) {
        if (a.body_style != b.body_style) {
          return a.body_style.localeCompare(b.body_style);
        } else if (a.bed_length != b.bed_length) {
          return a.bed_length.localeCompare(b.bed_length);
        } else {
          return this.variantObjects[a.products[0]].position - this.variantObjects[b.products[0]].position;
        }
      } else {
        return 0;
      }
    });

    window.__VPV.vehicleData.bySelection = window.__VPV.vehicleData.byVehicle.filter(vehicleObj => {
      const bedMatches = bed_length ? vehicleObj.bed_length === bed_length : true;
      const bodyStyleMatches = body_style ? vehicleObj.body_style === body_style : true;
      return bedMatches && bodyStyleMatches;
    });

    const title = `${make} ${model} ${year}`;

    this.#selectedVehicle = {
      title: title,
      make: make,
      model: model,
      year: year,
      body_style: body_style,
      bed_length: bed_length,
    };

    const vehicleSelectedEvent = new CustomEvent("vehicleSelected", {
      detail: this.#selectedVehicle,
      bubbles: true,
      cancelable: true,
      composed: false,
    });

    this.saveData("selectedVehicle", this.#selectedVehicle);

    window.__VPV.vehicleSelected = true;
    window.__VPV.updateStore({ vehicleSelected: true, productVehiclePickerOpen: false });
    document.dispatchEvent(vehicleSelectedEvent);
  }

  static resetSelectedVehicle() {
    window.__VPV.vehicleSelected = false;
    window.__VPV.updateStore({ vehicleSelected: false, productVehiclePickerOpen: true });
    this.saveData("selectedVehicle", {}, false, true);
    this.#selectedVehicle = null;
  }

  static reset() {
    window.__VPV.vehicleSelected = false;
    window.__VPV.updateStore({ vehicleSelected: false, productVehiclePickerOpen: true, urlSetVehicleData: false });
    window.__VPV.urlSetVehicleData = false;
    this.saveData("selectedVehicle", {}, false, true);
    this.saveData("variants", null);
    this.#selectedVehicle = null;
    this.selectedVariant = false;

    // Clear vehicle-related URL parameters
    this.clearVehicleUrlParams();

    document.dispatchEvent(
      new CustomEvent("vehicleCleared", {
        detail: {},
        bubbles: true,
        cancelable: true,
        composed: false,
      })
    );
  }

  static clearVehicleUrlParams() {
    const url = new URL(window.location);
    const vehicleParams = ['make', 'model', 'year', 'body_style', 'bed_length', 'variant'];

    vehicleParams.forEach(param => {
      url.searchParams.delete(param);
    });

    window.history.replaceState({}, '', url);
  }

  static storeVariant(variant) {
    this.saveData("variants", {
      [variant.id]: variant,
    });
  }

  static getStoredVariant(variantID) {
    let variants = this.getData("variants") || {};
    return variants[variantID];
  }

  static #accessToken = window.storefront?.apiKey || "21bb34a0fab877a09e210fd1b09dab81";
  static storeURL = window.storefront?.domain ? `https://${window.storefront?.domain}` : "https://decked-test.myshopify.com";

  static queryVariants = `
              query variants($country: CountryCode!, $ids: [ID!]!) @inContext(country: $country) {
                nodes(ids: $ids) {
                  ... on ProductVariant {
                    id
                    availableForSale
                    product {
                      description
                      handle
                      productType
                      title
                      ${productMetafields}
                      reviewsAverage: metafield(namespace:"yotpo", key:"reviews_average") {
                        value
                      }
                      reviewsCount: metafield(namespace:"yotpo", key:"reviews_count") {
                        value
                      }
                    }
                    image {
                      altText
                      url
                      width
                      height
                    }
                    title
                    sku
                    compareAtPrice{
                      amount
                      currencyCode
                    }
                    selectedOptions {
                      name
                      value
                    }
                    price {
                      amount
                      currencyCode
                    }
                    priceV2 {
                      amount
                      currencyCode
                    }
                    variantBodyNote: metafield(namespace:"vehicle", key: "body-note") {
                      value
                    }
                    ${variantParentCompatibility}
                    ${variantCompatible}
                    ${variantNotCompatible}
                    ${variantTechNotes}
                    ${variantTechSpecs}
                  }
                }
              }

              ${CoreCompatibilityFrag}
            `;

  static async getProductDataByVariantIDs(variantIDs) {
    const product = {};
    const variants = [];

    const newVariantIDs = variantIDs.filter(variantID => {
      const variant = this.getStoredVariant(variantID);

      if (variant) {
        variants.push(variant);
      } else {
        return true;
      }
    });

    const productData = await this.fetchProductDataByIDs(newVariantIDs).then(productData => {
      productData.variants.forEach(variant => {
        variants.push(variant);
        this.storeVariant(variant);
      });

      product.variants = variants;
      window.__VPV.pdp.variantReqData = variants;

      document.dispatchEvent(
        new CustomEvent("vehicleVarsDataReady", {
          detail: variants,
          bubbles: true,
          cancelable: true,
          composed: false,
        })
      );

      return product;
    });

    return productData;
  }

  static async fetchProductDataByIDs(productGlobalIDs, retryCount = 0) {
    const headers = {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": this.#accessToken,
      Accept: "application/json",
    };

    const data = await fetch(`${this.storeURL}/api/2023-04/graphql.json`, {
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        query: this.queryVariants,
        variables: {
          ids: [...productGlobalIDs],
          country: Shopify.country,
        },
      }),
    })
    .then(res => res.json())
    .then(result => this.parseResponseData(result))
    .then(data => {
      return data;
    })
    .catch(err => {
      console.error("WB err", err);
      if (retryCount < 2) {
        console.log("Retrying fetch...");
        return this.fetchProductDataByIDs(productGlobalIDs, retryCount + 1);
      }
      return null;
    });

    if (!data) {
      console.error("Could not fetch variant data: Network or API error after retry", productGlobalIDs);
      return { variants: [] };
    }

    if (!data.variants || data.variants.length != productGlobalIDs.length) {
      console.error("Could not fetch variant data: The product is probably not avalible on the storefront API", productGlobalIDs);
    }

    return data;
  }

  static extractVariantId(url) {
    const regex = /ProductVariant\/(\d+)/;
    const match = url.match(regex);
    if (match) {
      return match[1];
    } else {
      throw new Error("Invalid URL:" + url);
    }
  }

  static cleanReferences(references) {
    // Flattens references and nodes
    return references.edges.map(edge => {
      const { node } = edge;
      // Flatten value fields when value is only field
      const newObj = {};
      Object.values(node).forEach((field, idx) => {
        if (!field || typeof field !== "object") return;
        const fieldKeys = Object.keys(field);
        const propsCount = fieldKeys.length;
        const hasValue = fieldKeys.includes("value");
        const newKey = Object.keys(node)[idx];

        if (propsCount === 1 && hasValue) {
          newObj[newKey] = this.convertIfJson(field.value);
        } else {
          newObj[newKey] = field;
        }
      });
      return newObj;
    });
  }

  static convertIfJson(str) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  }

  static parseProductMetafields(productMetafields) {
    const newObj = {};
    productMetafields.forEach(metafield => {
      if (metafield?.key) {
        const standardizedKey = metafield.key.replace(/\-/g, "_");
        newObj[standardizedKey] = metafield.value === "true" ? true : metafield.value === "false" ? false : metafield.value;
      }
    });
    return newObj;
  }

  static parseResponseData(responseData) {
    const products = [];
    const nodes = responseData.data.nodes;

    const product = {
      variants: [],
    };

    for (const variantData of nodes) {
      if (variantData === null) continue;

      const parsedVariant = variantData;
      parsedVariant.gid = variantData.id;
      parsedVariant.id = this.extractVariantId(variantData.id);
      parsedVariant.productMetafields = this.parseProductMetafields(variantData.product.productMetafields);
      if (variantData.variantCompatible?.references) parsedVariant.variantCompatible = this.cleanReferences(variantData.variantCompatible.references);
      if (variantData.variantNotCompatible?.references) parsedVariant.variantNotCompatible = this.cleanReferences(variantData.variantNotCompatible.references);
      if (variantData.variantTechNotes?.references) parsedVariant.variantTechNotes = this.cleanReferences(variantData.variantTechNotes.references);
      delete variantData.product.productMetafields;

      product.variants.push(parsedVariant);
    }

    return product;
  }

  static saveData(key, value, session = false, overwrite = false) {
    const storageType = session ? "sessionStorage" : "localStorage";
    if (overwrite) {
      window[storageType].setItem(key, JSON.stringify(value));
    } else {
      const existingData = this.getData(key);
      window[storageType].setItem(
        key,
        JSON.stringify({
          ...(existingData || {}),
          ...value,
        })
      );
    }
  }

  static getData(key, session = false) {
    const storageType = session ? "sessionStorage" : "localStorage";

    const data = window[storageType].getItem(key);
    if (data === null) {
      return null;
    }
    try {
      return JSON.parse(data);
    } catch (e) {
      console.log(e);
      return {};
    }
  }
}

window.VehicleData = VehicleData;


// add preview file if needed
const params = new URL(document.location).searchParams;
if(params.get('vp-preview')){
  if(params.get('vp-preview') == "null"){
    window.localStorage.removeItem('vehicleDataPreviewFile');
  }else{
    window.localStorage.setItem('vehicleDataPreviewFile', params.get('vp-preview'));
  }
}

// add set vehicle if needed
const p_make = params.get('make');
const p_model = params.get('model');
const p_year = params.get('year');
const p_body_style = params.get("body_style");
const p_bed_length = params.get("bed_length");

const vehicle = VehicleData.getData('selectedVehicle');
if (!vehicle || (p_make && vehicle.make != p_make) || (p_model && vehicle.model != p_model) || (p_year && vehicle.year != p_year) || (p_body_style && vehicle.body_style != p_body_style) || (p_bed_length && vehicle.bed_length != p_bed_length)) {
  const newVehicle = {
    ...vehicle,
    make: p_make,
    model: p_model,
    year: p_year,
    body_style: p_body_style,
    bed_length: p_bed_length,
  };
  VehicleData.saveData("selectedVehicle", newVehicle);
  window.__VPV = window.__VPV || {};
  window.__VPV.urlSetVehicleData = true;
  window.__VPV.updateStore?.({ urlSetVehicleData: true });
}

const selectedVariant = params.get("variant");
if (selectedVariant) {
  VehicleData.selectedVariant = selectedVariant;
  window.__VPV = window.__VPV || {};
  window.__VPV.urlSetVehicleData = true;
  window.__VPV.updateStore?.({ urlSetVehicleData: true });
}
